import {useState} from "react";
import {makeLxTranslations, useLxTranslations} from "@lxo-blocks/react";

const EMAIL_VALIDATION_TRANSLATION = makeLxTranslations({
    namespace: "emailValidationTranslations",
    translations: {
        VALID_EMAIL_IS_REQUIRED: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    }
})

export const useEmailValidation = () => {
    const [isValidEmail, setIsValidEmail] = useState(false);
    const {t} = useLxTranslations(EMAIL_VALIDATION_TRANSLATION);

    const emailPattern = /^ *(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-ZäöüÄÖÜ\-0-9]+\.)+[a-zA-Z]{2,})) *$/;

    const validateEmail = (email: string) => {
        var isValid = emailPattern.test(email);
        setIsValidEmail(isValid);
        return isValid ? true : t("VALID_EMAIL_IS_REQUIRED");
    };

    return {
        isValidEmail: isValidEmail,
        validateEmail: validateEmail,
    };
};
